import LinkButtonMore from "../../components/buttons/linkButtonMore/linkButtonMore"
import { appNavigate } from "../../utils/functions"
import * as style from "./sectionTitle.module.css"
import Mark from "../../components/svg/new/Mark"
import React, { useEffect, memo } from "react"
import parse from "html-react-parser"
import "aos/dist/aos.css"
import AOS from "aos"

const SectionTitle = ({
  title,
  btnName,
  SubTitle,
  Btnclass,
  href,
  Content,
  styleCss,
  classnames,
  type,
  animation,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {type === "horizontal" ? (
        <div className={`${classnames} ${style.mix_heading_wrap}`}>
          <div className={style.mix_heading}>
            <div className={style.mix_heading_Root}>
              <div className={style.viewAllLink}>
                <span data-aos="fade-up" data-aos-delay="50">
                  {title}
                </span>
                <a
                  href={href}
                  onClick={e => {
                    e.preventDefault()
                    appNavigate(href)
                  }}
                  style={styleCss}
                >
                  <LinkButtonMore Btnclass={Btnclass} btnText={btnName} />
                </a>
              </div>
              <h2 data-aos="fade-up" data-aos-delay="100">
                {SubTitle}
              </h2>
            </div>
            <p data-aos="fade-up" data-aos-delay="150">
              {parse(`${Content}`)}
            </p>
          </div>
        </div>
      ) : (
        <div className={`${classnames} ${style.mix_heading_wrap}`}>
          <div className={style.mix_heading}>
            <div className={style.viewAllLink}>
              {title &&
                (animation === "yes" ? (
                  <span>
                    {" "}
                    <i>
                      <Mark />
                    </i>{" "}
                    {title}
                  </span>
                ) : (
                  <span data-aos="fade-up" data-aos-delay="50">
                    <i>
                      <Mark />
                    </i>
                    {title}
                  </span>
                ))}

              <a
                href={href}
                onClick={e => {
                  e.preventDefault()
                  appNavigate(href)
                }}
                style={styleCss}
              >
                <LinkButtonMore Btnclass={Btnclass} btnText={btnName} />
              </a>
            </div>

            {animation === "yes" ? (
              <>
                <h2>{SubTitle}</h2>
                <p>{Content}</p>
              </>
            ) : (
              <>
                <h2 data-aos="fade-up" data-aos-delay="100">
                  {SubTitle}
                </h2>
                <p data-aos="fade-up" data-aos-delay="150">
                  {parse(`${Content}`)}
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default memo(SectionTitle)
